export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const isEnabled = () =>
  GA_MEASUREMENT_ID && process.env.NODE_ENV === "production";

export function initAnalytics() {
  if (!isEnabled()) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!isEnabled() || !window.gtag) {
    return;
  }

  window.gtag("event", "page_view", {
    page_path: path,
  });
}
